import React from 'react';
import Link from 'gatsby-link'

import settings from "../styles/settings.scss";
import headlineMD from '../img/headline-md.jpg';
import headlineXL from '../img/headline-xl.jpg';
import headline from '../img/headline.jpg';

const Header = () => (
    <header className="header">
        <div className="inner header__inner">
            <h1 className="header__native-headline">
                <Link to="/">Kündigungscheck</Link>
            </h1>

            <picture className="header__headline">
                <source srcSet={headlineXL} media={`(min-width: ${settings.xl})`} />
                <source srcSet={headlineMD} media={`(min-width: ${settings.md})`} />
                <img src={headline} />
            </picture>
        </div>
    </header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/layouts/header.js